<template>
  <div>
    <transition name="navbar">
      <navbar v-show="isLoggedIn" :user="user" :newMode="true"></navbar>
    </transition>
    <layout :newMode="true">
      <router-view :key="$route.fullPath">
        <div slot="topRightActions" v-if="isActionsRequired">
          <li><a href="#" class="legitRipple"><i class="icon-comment-discussion position-left"></i> Support<span class="legitRipple-ripple" style="left: 71.7688%; top: 57.5%; transform: translate3d(-50%, -50%, 0px); transition-duration: 0.2s, 0.5s; width: 214.552%;"></span></a></li>
          <li class="dropdown">
            <a href="#" class="dropdown-toggle legitRipple" data-toggle="dropdown">
              <i class="icon-gear position-left"></i>
              Settings
              <span class="caret"></span>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-user-lock"></i> Account security</a></li>
              <li><a href="#"><i class="icon-statistics"></i> Analytics</a></li>
              <li><a href="#"><i class="icon-accessibility"></i> Accessibility</a></li>
              <li class="divider"></li>
              <li><a href="#"><i class="icon-gear"></i> All settings</a></li>
            </ul>
          </li>
        </div>
      </router-view>
    </layout>
    <toast-container :toastConfig="{preventDuplicates: true}"></toast-container>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueSweetAlert from 'vue-sweetalert'
import VeeValidate from 'vee-validate'
// import vbclass from 'vue-body-class'

import Layout from '@/components/Layout'
import Navbar from '@/components/_partial/Navbar'
import aclMixin from './helpers/mixins/_aclMixin'
import NotificationService from '@/services/notification.service'
import UserService from '@/services/user.service'
import notificationHelper from '@/helpers/notification.helper'

Vue.use(VueSweetAlert)
Vue.use(VeeValidate)

export default {
  name: 'App',
  components: { Layout, Navbar },

  mixins: [aclMixin],

  data () {
    return {
      user: {},
      breadcrumbs: this.$breadcrumbs,
      notificationService: new NotificationService(),
      userService: new UserService()
    }
  },

  created () {
    // document.body.className = 'navbar-top'
    // this.use(vbclass, this.$router)
    this.userService.item(this.$store.getters.userId, (result) => {
      this.user = result
    })
  },

  mounted () {
    let $vm = this
    this.$socket.init()
    this.$socket.notificationCallback(notification => {
      if (notification.data) {
        const html = notificationHelper.toHtml(notification.data.content, notification.data.bindings)
        // $vm.$snotify.info(html, $vm.$snotify)
        let toast = {
          'body': html,
          'type': 'info',
          'bodyOutputType': 'TrustedHtml'
        }
        this.$vueOnToast.pop(toast)
        console.log(html)
        // this.$notify(html, 'info')
      } else {
        let toast = {
          'body': notification.title,
          'type': 'info',
          'bodyOutputType': 'TrustedHtml'
        }
        this.$vueOnToast.pop(toast)
        // $vm.$snotify.info(notification.title)
        console.log(notification.title, $vm.$snotify)
        // this.$notify(notification.title, 'info')
      }
    })

    this.ping()
  },

  methods: {
    ping () {
      this.userService.ping({
        params: {
          last_notification_id: this.notifications.last_notification_id
        }
      }, (data) => {
        let notifications = this.notifications
        notifications.last_notification_id = data.last_notification ? data.last_notification.id : notifications.last_notification_id

        if (data.notifications) {
          data.notifications.forEach(n => {
            n.html = notificationHelper.convert(n)

            notifications.list.push(n)
          })
        }

        this.$store.dispatch('setNotifications', notifications)

        setTimeout(this.ping, 30000)
      }, (err) => {
        console.log(err)
      })
    },

    breadcrumbLink (crumb) {
      // If it's a named route, we'll base the route
      // off of that instead
      if (crumb.name || (crumb.handler && crumb.handler.name)) {
        return {
          name: crumb.name || crumb.handler.name,
          params: this.$route.params
        }
      }

      return {
        path: crumb.handler && crumb.handler.fullPath ? crumb.handler.fullPath : crumb.path,
        params: this.$route.params
      }
    },
    crumbText (crumb) {
      return crumb.meta.breadcrumb
    },

    ...Vuex.mapActions(['logout']),

    logoutRedirect () {
      // Force vuex reset with $router.go
      this.logout().then(() => this.$router.go({ name: 'login' }))
    },

    getCurrentTitle () {
      if (this.$route.meta) {
        if (this.$route.meta.title) {
          return this.$route.meta.title
        }
      }
      return ''
    }

  },

  computed: {
    ...Vuex.mapGetters(['isLoggedIn', 'userName', 'boxed', 'fullscreen', 'isSidebarFull', 'notifications']),
    currentTitle: function () {
      return this.getCurrentTitle()
    },
    isActionsRequired: function () {
      if (this.$route.meta) {
        if (this.$route.meta.buttonsRequired) {
          return this.$route.meta.buttonsRequired
        }
      }
      return false
    }
  }

}
</script>

<style lang="scss">
  @import "./assets/css/icons/icomoon/styles.css";
  @import "./assets/css/bootstrap.min.css";
  @import "./assets/css/core.min.css";
  @import "./assets/css/components.min.css";
  @import "./assets/css/colors.min.css";
</style>

<style lang="less">
  @import "./assets/main.less";
</style>

<style>
  @import "./assets/css/swal.css";
  @import "./assets/style.css";
  @import "./assets/responsive.css";

  .navbar-enter, .content-enter {
    opacity: 0;
  }

  .navbar-leave-active, .content-leave-active {
    opacity: 0;
  }

  .navbar-enter .navbar,
  .navbar-leave-active .navbar,
  .content-enter .page-content,
  .content-leave-active .page-content {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .daterangepicker.dropdown-menu {
    z-index: 10000;
  }

  .swal2-container {
    z-index: 10001;
  }

  .control-label {
    font-weight: bold;
  }

</style>
